import { render, staticRenderFns } from "./select_product.vue?vue&type=template&id=fbb9e4ba&scoped=true"
import script from "./select_product.vue?vue&type=script&lang=js"
export * from "./select_product.vue?vue&type=script&lang=js"
import style0 from "./select_product.vue?vue&type=style&index=0&id=fbb9e4ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb9e4ba",
  null
  
)

export default component.exports